import { render, staticRenderFns } from "./Razones.vue?vue&type=template&id=f277ee70"
import script from "./Razones.vue?vue&type=script&lang=js"
export * from "./Razones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports